export const tipoImpressoToAlerta =  (tipo) => {
  if (tipo) {
    return `ALERTA_IMPRESSO_${tipo.toUpperCase()}`
  }
}
